// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GeneralPane_wrapper__1VB6n","paneTitle":"GeneralPane_paneTitle__S_uGI"};